import { useEffect, useState } from 'react';
import { DarkModeRounded, LightModeRounded } from '@mui/icons-material';

import Text from '@components/Text';
import { t } from '@i18n';

import './styles.scss';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getCurrentTheme);
  const isDark = theme === 'dark';

  useEffect(() => {
    const handleAppearanceChange = (event: Event) => {
      const customEvent = event as CustomEvent;
      setTheme(customEvent.detail || getCurrentTheme());
    };

    window.addEventListener('appearence-change', handleAppearanceChange);

    return () => {
      window.removeEventListener('appearence-change', handleAppearanceChange);
    };
  }, []);

  function handleToggle() {
    const nextTheme = isDark ? 'light' : 'dark';
    const appliedTheme = typeof window.triggerAppearence === 'function'
      ? window.triggerAppearence(nextTheme)
      : nextTheme;

    setTheme(appliedTheme || nextTheme);
  }

  return (
    <button
      type="button"
      className="checkout-theme-toggle"
      onClick={handleToggle}
      // the label names the theme in use; the aria-label names the theme the click would apply
      aria-label={isDark ? t('checkout.theme.enableLight') : t('checkout.theme.enableDark')}
    >
      {isDark ? <DarkModeRounded /> : <LightModeRounded />}
      <Text.caption>{isDark ? t('checkout.theme.dark') : t('checkout.theme.light')}</Text.caption>
    </button>
  );
}

function getCurrentTheme() {
  if (typeof window !== 'undefined' && window.appearenceMode) {
    return window.appearenceMode;
  }

  if (typeof document !== 'undefined' && document.body.classList.contains('dark')) {
    return 'dark';
  }

  return 'light';
}
